module.exports = __webpack_public_path__ + "static/media/cleaner.811306a7.svg";